import type { Nullable } from '@ricoh/ria.client.core/types/core/data.type';

import type { BrowserStorageType } from './_api.type';

const getStorage = (type: BrowserStorageType) => (type === 'local' ? globalThis.localStorage : globalThis.sessionStorage);

/** BrowserStorage API. */
const api = {
  getStorage,

  get: <TData>(type: BrowserStorageType, key: string): Nullable<TData> => {
    const storage = getStorage(type);

    const valueString = storage.getItem(key);
    if (!valueString) {
      return undefined;
    }

    return JSON.parse<TData>(valueString);
  },

  set: <TData>(type: BrowserStorageType, key: string, value: TData) => {
    const storage = getStorage(type);

    const valueString = JSON.stringify(value);
    storage.setItem(key, valueString);
  },

  remove: (type: BrowserStorageType, key: string) => {
    const storage = getStorage(type);

    storage.removeItem(key);
  },

  clear: (type: BrowserStorageType) => {
    const storage = getStorage(type);

    storage.clear();
  },
};

export default api;
